// extracted by mini-css-extract-plugin
module.exports = {"list":"collection-ArtistCollection__list--1509W"};